module.exports = __webpack_public_path__ + "img/sqlc_top.fb1bae2f.png";